export var CoreBadgeType;
(function(CoreBadgeType) {
    CoreBadgeType["GLASS"] = 'glass';
    CoreBadgeType["EMERALD"] = 'emerald';
    CoreBadgeType["DIAMOND"] = 'diamond';
})(CoreBadgeType || (CoreBadgeType = {}));
